import { Image } from 'expo-image';
import { StyleSheet, TouchableOpacity, View } from 'react-native';

import Text from '@/components/Text';
import { BLUR_HASH } from '@/constants/layout';

interface SeasonMissionParticipantCardProps {
  title: string;
  description: string;
  image: any;
  height?: number;
  width?: number;
  onPress: () => void;
}

const SeasonMissionParticipantCard = ({
  title,
  description,
  image,
  height,
  width,
  onPress
}: SeasonMissionParticipantCardProps) => {
  const style = useStyle(height, width);

  return (
    <TouchableOpacity onPress={onPress} activeOpacity={0.8}>
      <View style={style.mainContainer}>
        <Image style={style.imageStyle} source={image} contentFit="cover" placeholder={{ blurhash: BLUR_HASH }} />

        <View style={style.textContainer}>
          <Text style={style.title} fontWeight="900" numberOfLines={2}>
            {title.toUpperCase()}
          </Text>

          <Text style={style.description} numberOfLines={2}>
            {description}
          </Text>
        </View>
      </View>
    </TouchableOpacity>
  );
};

export default SeasonMissionParticipantCard;

const useStyle = (height: number | undefined, width: number | undefined) => {
  const style = StyleSheet.create({
    mainContainer: {
      height: height ?? 240,
      width: width ?? '100%',
      borderRadius: 10,
      overflow: 'hidden',
      justifyContent: 'flex-end',
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 2 },
      shadowOpacity: 0.15,
      shadowRadius: 4,
      elevation: 4
    },

    imageStyle: {
      ...StyleSheet.absoluteFill
    },

    textContainer: {
      backgroundColor: 'rgba(0,0,0,0.4)',
      paddingHorizontal: 16,
      paddingVertical: 12,
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%'
    },

    title: {
      color: 'white',
      letterSpacing: -0.36,
      fontSize: 18,
      textAlign: 'center',
      marginBottom: 4
    },

    description: {
      color: 'white',
      fontSize: 14,
      textAlign: 'center'
    }
  });

  return style;
};
